import React, { useEffect, useRef } from 'react'
import className from 'classnames/bind'

import style from './MyhouseMainAssetTab.module.scss'

import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import { MODAL_TYPE } from '@Root/contants/myhouseModal'
import IconAdd59x28 from '@Ui/images/myhouse/IconAdd59x28.svg'
import ArrowLeft8x14 from '@Ui/images/myhouse/ArrowLeft8x14.svg'
import useModal from '@Root/hooks/myhouse/useModal'
import { MyhouseLabelType } from '@Root/utils/houseLabelUtils'
import { handleNclick, handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'
import { MYHOUSE_MAX_COUNT } from '@Root/contants/myhouseRegister'

const cx = className.bind(style)

type Props = {
  houses: MyhouseLabelType[]
  currentHouseNo: number
  handleHouseClick: (event: React.SyntheticEvent, houseNo: number) => void
}

const MyhouseMainAssetTab: React.FC<Props> = ({ houses, currentHouseNo, handleHouseClick }: Props) => {
  const { open } = useModal()
  const refScrollingElement = useRef<HTMLDivElement>(null)

  const onClickAddHouse = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (houses.length >= MYHOUSE_MAX_COUNT) {
      open(MODAL_TYPE.MYHOUSE_LIMITED, {
        nclickConfirm: NCLICK.MY_HOUSE.LIST.LIMIT.SETTING,
        nclickCancel: NCLICK.MY_HOUSE.LIST.LIMIT.CLOSE,
      })
      event.preventDefault()
    }
    handleNclick(NCLICK.MY_HOUSE.LIST.ADD, event)
  }

  useEffect(() => {
    const scrollingElement = refScrollingElement.current as HTMLDivElement
    scrollingElement.querySelectorAll('a').forEach((item, i) => {
      if (currentHouseNo === (houses[i] as MyhouseLabelType)?.houseNo) {
        if (item.scrollIntoView) {
          item.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'center' })
        } else {
          const width = scrollingElement.getBoundingClientRect().width
          scrollingElement.scrollLeft = item.offsetLeft - (width - item.getBoundingClientRect().width) / 2
        }
      }
    })
  }, [currentHouseNo])

  return (
    <div className={cx('article')} role="tablist">
      <div className={cx('tab')} ref={refScrollingElement}>
        {houses.map((house: { houseNo: number; houseLabel: string; additionalInfo: string }, index: number) => (
          // [D] 현재 탭인 경우 is-active 클래스 추가
          <a
            href="#"
            key={house.houseNo}
            className={cx('title', currentHouseNo === house.houseNo && 'is_active')}
            onClick={handleNclickMix(NCLICK.MY_HOUSE.LIST.TAB, (e) => handleHouseClick(e, house.houseNo))}
          >
            {house.houseLabel}
            {Boolean(house.additionalInfo) && <span className={cx('detail')}>{house.additionalInfo}</span>}
          </a>
        ))}

        <a href={`${LAND_SERVICE_PREFIX_URL.MYHOUSE_REGISTER}/address`} className={cx('link_add')} aria-label="추가" role="button" onClick={(e) => onClickAddHouse(e)}>
          <IconAdd59x28 />
        </a>
      </div>
      {/* [D] 스크롤 버튼은 pc화면에서 탭 스크롤 상황에 따라서 노출 처리가 필요할 때 is_active클래스 추가 */}
      <button type="button" className={cx('button_left', 'is_active')}>
        <ArrowLeft8x14 />
        <span className="blind">좌측스크롤</span>
      </button>
      <button type="button" className={cx('button_right', 'is_active')}>
        <ArrowLeft8x14 />
        <span className="blind">우측스크롤</span>
      </button>
    </div>
  )
}

export default MyhouseMainAssetTab
